import { Action, ActionCreator } from 'redux';
import { timeStampUtc } from '../../../utils/dateUtils';
import { SESSION_RESET } from '../sessionIndex';

export interface IStoreSessionResetAction extends Action {
  type: typeof SESSION_RESET;
  payload: IStoreSessionCreateActionPayload;
}

interface IStoreSessionCreateActionPayload {
  isAuthenticated: boolean;
  timestamp: number;
}

export const sessionResetAction: ActionCreator<IStoreSessionResetAction> = () => ({
  type: SESSION_RESET,

  payload: {
    isAuthenticated: false,
    timestamp: timeStampUtc(),
  },
});
